<template>
    <div class="editable-date">
        <editable :value.sync="value"
                  :display-value="displayValue"
                  :placeholder="placeholder">
            <div slot="editor" class="editor">
                <datepicker :value.sync="editValue"
                            :placeholder="placeholder"
                            format="dd/MM/yyyy"
                            width="130px"
                            :show-reset-button="enableReset"></datepicker>
            </div>
        </editable>
    </div>
</template>

<style scoped
       lang="less">
    @import '~src/style/variables';

    .editable-date {
        display: inline-block;
    }

    .editor {
        font-size: @font-size-base;
    }

    .editing {
        display: inline-flex;
        align-items: center;

        .btn-group {
            margin-left: 5px;
        }
    }

    .placeholder {
        font-style: italic;
        color: lighten(@text-color, 20%);
    }

    .datepicker {
        color: @text-color;
    }
</style>

<script type="text/ecmascript-6">
    import Datepicker from 'vue-strap/src/Datepicker';
    import Editable from './Editable';
    import moment from 'moment';

    export default {
        components: {
            Datepicker,
            Editable
        },
        props: {
            placeholder: {
                'default': 'Date...'
            },
            value: {
                twoWay: true,
                'default': ''
            },
            enableReset: {
                'default': false
            }
        },
        computed: {
            displayValue() {
                return moment(this.value, 'YYYY-MM-DD').format('LL');
            }
        },
        data() {
            return {
                editValue: '',
                editing: false,
                editable: true
            };
        },
        events: {
            'editable:childStartEdition': function () {
                if (this.value) {
                    this.editValue = moment(this.value, 'YYYY-MM-DD').format('DD/MM/YYYY');
                } else {
                    this.editValue = '';
                }
            },
            'editable:childValidateEdition': function () {
                if (this.editValue) {
                    const val = moment(this.editValue, 'DD/MM/YYYY');

                    if (val.isValid()) {
                        this.value = val.format('YYYY-MM-DD');
                        return;
                    }
                }

                this.value = '';
            }
        }
    };
</script>



// WEBPACK FOOTER //
// EditableDate.vue?b73a516c